import styles from "./AvatarOrb.module.css";

type Props = {
  initials: string;
  online?: boolean;
  small?: boolean;
};

export function AvatarOrb({ initials, online, small }: Props) {
  return (
    <div
      className={`${styles.orb} ${small ? styles.orbSmall : ""} ${online ? styles.online : ""}`}
      aria-hidden
    >
      {initials}
    </div>
  );
}
